<script>
  import { ignore } from "../../Common/tools";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import Slider from "../../Common/Slider.svelte";
  import Checkbox from "../../Common/Checkbox.svelte";
  import {External, M} from "../../external";

  export let widget,
    onChange = ignore;
  let data = widget.data,
    widgetUi = widget.$widget;

  let fonts = External.GlobalStyling.getAvailableFontNames() || [];
  data.tileFontSize = data.tileFontSize || 18;
  data.tileDescFontFamily = data.tileDescFontFamily || "Open Sans";
  data.tileDescFontSize = data.tileDescFontSize || 14;
</script>

<div class="popup-widget-wrapper">
  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.tileColor} bind:colorClass={data.tileColorClass} label={M.TEXT_COLOR} onChange={onChange} />
  </div>

  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.tileBgColor} bind:colorClass={data.tileBgColorClass} label={M.BACKGROUND_COLOR} onChange={onChange} />
  </div>

  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.tileBorderColor} bind:colorClass={data.tileBorderColorClass} label={M.BORDER_COLOR} onChange={onChange} />
  </div>

  <Checkbox onChange={onChange} bind:data={data.addShadowToSelectedOptions} label={M.OPTION_BOX_ADD_SHADOW} />
  
  <div class="col20 f-left gray-section section-gray-box mt-5">
    <h4 class="col20 f-left">{M.TITLE}</h4>

    <div class="input-wrapper col20 f-left mt-15">
      <div class="info">
        <h5>{M.FONT}</h5>
      </div>
      <select bind:value={data.tileFontFamily} on:change={onChange}>
        {#each fonts as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>

    <div class="input-wrapper col20 f-left">
      <Slider bind:value={data.tileFontSize} min={1} max={100} label={M.FONT_SIZE} onChange={onChange} />
    </div>

  </div>

  <div class="col20 f-left gray-section section-gray-box mt-15">
    <h4 class="col20 f-left">{M.DESCRIPTION}</h4>

    <div class="input-wrapper col20 f-left mt-15">
      <div class="info">
        <h5>{M.FONT}</h5>
      </div>
      <select bind:value={data.tileDescFontFamily} on:change={onChange}>
        {#each fonts as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>

    <div class="input-wrapper col20 f-left">
      <Slider bind:value={data.tileDescFontSize} min={1} max={100} label={M.FONT_SIZE} onChange={onChange} />
    </div>
  </div>
</div>
